import { Grid } from "@mui/material"
import { useAuthContext } from "src/hooks"
import { theme } from "src/providers/ThemeProvider"
import { UserContent, HomeContent } from "src/pages"

const MainContent = () => {
  const { hasAuthenticated, profile } = useAuthContext()

  return (
    <Grid
      alignContent="center"
      justifyContent="center"
      container
      direction="column"
      width="100%"
      padding={theme.spacing(10, 0, 6)}
      sx={{
        [theme.breakpoints.down(600)]: {
          padding: theme.spacing(8, 0, 4),
        },
      }}
      gap={3}
    >
      {hasAuthenticated && !!profile ? <UserContent /> : <HomeContent />}
    </Grid>
  )
}

export default MainContent
